import {getKeyedCopy, type KeyedCopyEntry} from "@repo/utils/keyedCopy";
import {CLASS_SCHEDULE_COPY} from "../ClassScheduleCopyConstants";

/**
 * Resolve the "few seats remaining" threshold from keyed copy, defaulting to 10.
 */
export function getFewSeatsRemainingThreshold(
	keyedCopy: KeyedCopyEntry[] = []
): number {
	// Get the value from keyed copy and parse it as an integer.
	const raw = getKeyedCopy(
		keyedCopy,
		CLASS_SCHEDULE_COPY.fewSeatsRemaining.threshold
	);
	const parsed = Number.parseInt(raw, 10);

	// If a bad value is provided, return the fallback.
	if (!Number.isFinite(parsed) || parsed < 0) {
		return Number.parseInt(
			CLASS_SCHEDULE_COPY.fewSeatsRemaining.threshold.fallback,
			10
		);
	}

	return parsed;
}

/**
 * True when remaining seats are at least one and at or below the threshold.
 */
export function isFewSeatsRemaining(
	seatsAvailable: number,
	threshold: number
): boolean {
	if (threshold < 0) {
		return false;
	}

	return seatsAvailable > 0 && seatsAvailable <= threshold;
}
